import * as r from '@recoiljs/refine';
import { atom } from 'recoil';
import { urlSyncEffect } from 'recoil-sync';

export interface EmployeeChangesFilters {
	status: string[];
	employee: string[];
	trainings: string[];
	types: string[];
}
const stringArrayChecker = r.array(r.string()) as r.Checker<string[]>;
const objectArrayChecker = r.array(
	r.object({
		id: r.number(),
		name: r.string(),
	}),
) as r.Checker<{ id: number; name: string }[]>;
export const EmployeeChangesFiltersAtom = atom<EmployeeChangesFilters>({
	key: 'employeeChangesFilters',
	default: {
		status: [],
		employee: [],
		trainings: [],
		types: [],
	},
	effects: [
		urlSyncEffect<EmployeeChangesFilters>({
			refine: r.object({
				status: stringArrayChecker,
				employee: stringArrayChecker,
				trainings: stringArrayChecker,
				types: stringArrayChecker,
			}),
			history: 'push',
		}),
	],
});
